module.exports = __webpack_public_path__ + "static/media/clutch_logo.bdaabf10.png";